import React from 'react';
import { useParams } from 'react-router-dom';
import ArticleCard from '../components/ArticleCard';
import { articles } from '../data/news';

function Author() {
  const { slug } = useParams();
  const name = slug.split('-').map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
  const authored = articles.filter((article) => article.author.toLowerCase().replaceAll(' ', '-') === slug);
  return (
    <div className="shell page-space">
      <section className="author-profile">
        <div className="author-large">{name.charAt(0)}</div>
        <div><span className="eyebrow">OPINIGURU AUTHOR</span><h1>{name}</h1><p>Journalist and commentator covering public affairs, policy and the ideas shaping Sri Lanka and the wider region.</p><a href="mailto:editorial@example.com">Contact author</a></div>
      </section>
      <div className="section-heading large"><span>Latest from {name}</span></div>
      <div className="listing-grid">{(authored.length ? authored : articles.slice(0, 4)).map((article) => <ArticleCard key={article.id} article={article} horizontal />)}</div>
    </div>
  );
}

export default Author;